import React from 'react'

import {
  Paper,
  Table,
  TableBody,
} from '@material-ui/core'
import Skeleton from '@material-ui/lab/Skeleton';

import TableHeader from './tableHeader'
import TableRow from './tableRow'

import useStyles from './styles'

const TableComponent = (props) => {
  const classes = useStyles()
  const { 
    promotions, 
    isLoadingPromotions, 
    currentPage, 
    onUpdateDetail, 
    onPauseActivate,
    onDelete
  } = props

  return (
    <Table>
      {isLoadingPromotions && currentPage === 1
        ?
        <div>
          <Skeleton height={80} />
          <Skeleton height={80} />
          <Skeleton height={80} />
        </div>
        :
        <>
          <TableHeader />
          <TableBody>
            {promotions.map((item) => (
              <TableRow
                key={item.id}
                item={item}
                onUpdateDetail={onUpdateDetail}
                onPauseActivate={onPauseActivate}
                onDelete={onDelete}
              />
            ))}
          </TableBody>
        </>
      }
    </Table>
  )
}

export default TableComponent